// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function chileanOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'cl',
    document_type: userInputValues['chileanDocumentType'],
    document: userInputValues['chileanDocument'],
    zipcode: userInputValues['chileanZipcode'],
    state: userInputValues['chileanState'],
    city: userInputValues['chileanCity'],
    address: userInputValues['chileanAddress'],
    street_number: userInputValues['chileanStreetNumber'],
    street_complement: userInputValues['chileanStreetComplement'],
    phone_number: userInputValues['chileanPhoneNumber'],
  };
}
